import { createStore, createEffect, createEvent, combine } from 'effector';
import { $notificationStore } from '../notificationStore';
import { ApiUtils } from '@shared/utils';
import { UsersApi, type DeleteUserAccountsRequest, type ProfileResponse } from '@shared/api';

const deleteUserAccountsEffect = createEffect((request: DeleteUserAccountsRequest) => UsersApi.deleteUserAccounts(request));
const clearEvent = createEvent();

const $dataStore = createStore<ProfileResponse | null>(null)
  .on(deleteUserAccountsEffect.done, (current, data) => data.result.data || current)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(deleteUserAccountsEffect.pending, (_, data) => data)
  .on(deleteUserAccountsEffect.fail, () => false)
  .on(deleteUserAccountsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(deleteUserAccountsEffect, () => null)
  .on(
    deleteUserAccountsEffect.fail,
    (_, data) => ApiUtils.getApiErrorData(data.error, 'Something went wrong while deleting Manager. Please try again.').message,
  )
  .on(deleteUserAccountsEffect.done, () => null)
  .reset(clearEvent);
$errorStore.watch((error) => $notificationStore.events.setError(error));

export const $deleteUserAccountsStore = {
  events: {
    deleteUserAccounts: deleteUserAccountsEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
